import { COMMON_MOBILE_BREAKPOINT } from '@elfsight/lib-utils';

export const MOBILE_BREAKPOINT = COMMON_MOBILE_BREAKPOINT;
export const MEDIUM_BREAKPOINT = 768;
